module.exports = __webpack_public_path__ + "media/images/form-status-evaluated-0829741e.gif";